export default {
    cart: {
      account: 'Thanh toán'       
    },
    tips: {
      cart_success: "Đã được thêm thành công vào giỏ hàng",   
      add_success: "Thêm thành công",            
      empty: "Cái gì cũng không có thêm vào~",                 
      order_success: "Xin chúc mừng, đơn hàng được gửi thành công",
      chose: "Hãy chọn",                      
      un_pay_on_line: "Tạm thời không hỗ trợ thanh toán trực tuyến",   
      area_not_empty: "Vùng không thể để trống",       
      name_not_empty: "Họ tên không thể để trống",       
      address_not_empty: "Địa chỉ không thể để trống",    
      phone_not_empty: "Số điện thoại không đúng"       
    },
    detail: {
      carriage: 'Chi phí vân chuyển',                    
      surplus: 'Còn lại',                     
      goods_detail: 'Thông tin chi tiết sản phẩm',            
      cart: 'Giỏ hàng',                      
      add_cart: 'Thêm  vào giỏ hàng',              
      buy_now: 'Mua ngay',                 
      Subtotal:'Tổng phụ',             
      CloseOrder:'Kết thúc đặt hàng',        
      Total:'Tổng cộng',               
      mange:'sự quản lý',         
      jian:'Cái',                           
      Delivery_method:'Phương thức vận chuyển hàng hóa',
      paypaly_method:'Phương thức thanh toán',
      paypaly1:'Thanh toán khi giao hàng',
      paypaly2:'Thanh toán trực tuyến',
      paypalyOut:'Đang trong quá trình phát triển, hãy kiên nhẫn chờ đợi.',
    },
    order: {
      freeFreight:'Giảm tải',
      allTotal:'Giá cả hàng hóa',
      query:'Yêu cầu trật tự',
      goods_info: 'Thông tin hàng hóa',             
      pay_way: 'Chọn phương thức vận chuyển và thanh toán ',      
      offline: 'Thanh toán khi giao hàng',                
      online: 'Thanh toán trực tuyến',                 
      pick_info: 'Thông tin giao hàng',              
      name_name: ' Họ tên',                 
      name: 'Họ tên của người nhận hàng',                 
      phone_name: 'Số điện thoại',                 
      phone: 'Số điện thoại của người nhận hàng',              
      area: 'Tỉnh, thành phố, huyện, vv',               
      region: 'Khu vực',                                      
      address_name: 'Địa chỉ',           
      address: 'Số đường, số phòng và các thông tin khác', 
      offer_order: 'Gửi đơn đặt hàng ',                    
    }, 
    data: {
      Recipient_name:'Họ tên của người nhận hàng',        
      Recipient_nameTips:'Vui lòng điền tên thật của người nhận để đảm bảo nhận được thông suốt',  
      Select_M:'Chọn một cửa hàng',                
      email:"Email của người nhận",                 
      Select_M_number:'Tên cửa hàng',                
      Selected_store_name:'Chọn tên cửa hàng', 
      Shop_address:'Địa chỉ cửa hàng',             
      address:'Xin hãy chọn địa chỉ ',               
      Choose_payment_method:'Chọn phương thức thanh toán',   
      default_address:' Đài Loan',           
    },
    indexdata:{
      index:'Trang chủ',                       
      list:'Danh sách',                        
      placeholder:'Nhập từ khóa tìm kiếm',       
      Return:'Trở về'                       
    },
    Product_details_page: {
      guarantee:'Bảo hành',                   
      guarantee_texts: 'Genuine guarantee, fake one compensation, four fast refund',
      numbertext:'Số lượng ',                  
      Select_product_specification:'Chọn thông số kỹ thuật sản phẩm',   
      Package_selection: 'Lựa chọn gói',      
      Buy_now: 'Mua ngay'                 
    },
    newOrder:{
      Order_information:'Thông tin đặt hàng  ',       
      Selection_of_delivery_and_payment_methods:'Chọn phương thức vận chuyển và thanh toán',   
      Delivery_place:'Địa chỉ nhận hàng',          
      tw:'Đài Loan',                      
      Delivery_method:'Phương thức giao hàng',         
      Sub_total:'Tổng phụ',                   
      Freight_charges:'Hàng hóa',             
      Total:'Tổng cộng',                       
      Go_to_checkout:' Thanh toán',         
    },
    order3: {
      Total:'Tổng cộng  ₫',                 
      Delivery_information:'Thông tin giao hàng',   
      Freight_charges:'Hàng hóa',            
      change:'thay đổi',                                  
      Search_shop:'Tìm kiếm cửa hàng ',                     
      Order_notes:'Ghi chú đơn đặt hàng',            
      Payment_information:'Thông tin thanh toán ',    
      Payment_method_selected:'Phương thức thanh toán được chọn', 
      Submit_order: 'Gửi đơn đặt hàng',          
      xxdz:' Vui lòng nhập địa chỉ chi tiết',            
      Select_address: 'Chọn địa chỉ',        
      Tell_the_seller:'Bạn có gì muốn nói với người bán?',  
      freight:"Phí vận chuyển:",             
      Spesifikasi_jualan_pendek:'Cái này đã  được bán hết',  
    },
    index:{
      placeholder:'Hãy nhập từ khóa tìm kiếm',    
      index:'Trang Chủ',                      
      list: 'Danh sách',                      
      language:'Chọn một ngôn ngữ'                
    },
    Guarantee:{
      num:'Số',
      Pickup_method:'Hỗ trợ 7-11,FamilyMart giao hàng',
      Guarantee:' Đảm bảo chất lượng',                        
      Freight:'Miễn phí vận chuyển',                  
      Commodity_pic:'Hình ảnh sản phẩm',            
      Options:'Tùy chọn',                    
      selected:'Đã chọn',                   
      Total_price:' Tổng giá đặt hàng',           
      Finally_cope:'Cuối cùng thanh toán',           
      message:'Để lại lời nhắn',                    
      region:' Huyện / Thành phố',       
      region_s:'Thị trấn / thị trấn / quận',               
      country:' Quốc gia / khu vực',
      village: 'Huyện/thị trấn'             
    },
    Pay:{
      language:'Thanh toán khi giao hàng',               
      money:'₫',
      to:'Chuyển đến trang chủ trong vài giây',               
      postcode:'Mã bưu điện',          
      setMeal:'Giá gói kết hợp',         
      success:'Đặt hàng thành công!',               
      time:'Người bán sẽ tự động xác nhận đơn hàng của bạn trong vòng 10 phút!',
      realMoney:'Số tiền thực trả',
      orderNumber:'Số đơn hàng',
      waitFor:'Thương gia không giao hàng, vui lòng kiên nhẫn đợi'
    },
    comment:{
      comment:'Gửi bình luận',                
      Praise:'Đánh giá cao',                     
      Average:'Đánh giá vừa',                    
      Badreview:'Đánh giá xấu',                  
      submitcomments:' Gửi bình luận',        
      PleaseEnteraComment:'Vui lòng nhập một bình luận'   
    },
    Toast:{
      inputName:'Vui lòng nhập tên',            
      inputPhone:'Vui lòng nhập số điện thoại',         
      inputZip:'Vui lòng nhập mã bưu điện',             
      inputAddress:' Vui lòng nhập địa chỉ  chi tiết',    
      inputAlertAddress:'Địa chỉ này không được gửi, vui lòng đổi sang địa chỉ khác',
    },
    contactUs:{
      callMe:'To learn more <br>,Pls contact the Messenger of our Facebook page!',
      afterShop:`Already shopping,Pls contact us: <br> Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
      confirm:'OK',
      shortSale:'Giá trị đã được bán hết',
    },
    ensure:{
      introduce:'Nhập vào',
      Specifications:'Đặc trưng hóa',
      ensure:'Bảo lãnh may',
      di:'',
      commodity:'th item'
    },
    wuliu:{
      orderSearch:'订单查询',
      provide:'本數據由物流官方提供',
      OrderOrLogistics:'訂單號/物流單號(填寫一項即可查詢)',
      orderPlaceho:'填寫相關訊息查詢',
      query:'查询订单号',
      Tips:'温馨提示',
      Tipsinfo:'收到商品後有任何疑問請聯繫在線客服或發郵件至service325@hotmail.com。同時請告知您的姓名/聯繫方式/訂單編號，我們會快速的給您及時處理，祝您購物愉快！',
    }
  }
  


// WEBPACK FOOTER //
// ./src/i18n/yn.js